import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className='flex flex-col w-full min-h-screen'>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
